import { Component, OnDestroy, OnInit, inject, isDevMode } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { AuthLayoutComponent } from '@features/auth/shared/components/auth-layout/auth-layout.component';
import { TranslocoModule } from '@ngneat/transloco';
import { SSOAccountFirstLoginFormOTPService } from './account-first-login-otp.service';
import { WEB_ROUTE_SSO_XAC_MINH_LAN_DAU, LINK_SUPPORT } from '@features/auth/const';
import { ActivatedRoute, Router } from '@angular/router';
import { navigateWithQueryParams } from '@features/auth/shared/redirect/redirect-helper';
import { SSOInputOtpComponent } from './components/input-otp/input-otp.component';
import { SSOFinishedFormComponent, SSOChangeDefaultPasswordComponent } from './components/public-api';
import { SSOVerifyDeviceComponent } from './components/verify-device/verify-device.component';
import { SSOVerifyEmailComponent } from './components/verify-email/form-email.component';
import { SSOVerifyPhoneComponent } from './components/verify-phone/verify-phone.component';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    AuthLayoutComponent,
    SSOFinishedFormComponent,
    SSOVerifyEmailComponent,
    SSOChangeDefaultPasswordComponent,
    SSOVerifyDeviceComponent,
    SSOInputOtpComponent,
    SSOVerifyPhoneComponent,
  ],
  providers: [],
  selector: 'app-sso-form-nhap',
  templateUrl: './require-update-info.component.html',
  styleUrls: ['./require-update-info.component.scss'],
})
export class SSOFormCapNhatThongTin implements OnInit, OnDestroy {
  readonly otpFormService = inject(SSOAccountFirstLoginFormOTPService);
  private readonly activatedRoute = inject(ActivatedRoute);
  destroy$$ = new Subject<void>();

  support_link = LINK_SUPPORT.VERIFY_ACCOUNT_AT_LOGIN;

  router = inject(Router);

  ngOnInit() {
    this.otpFormService.activeFormByKey();
  }

  ngOnDestroy(): void {
    this.destroy$$.next();
    this.destroy$$.complete();
  }

  navigateToLogin() {
    navigateWithQueryParams(this.router, [WEB_ROUTE_SSO_XAC_MINH_LAN_DAU]);
  }
}
